import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { buildMemberMessagesPageLink } from 'Views/Page/Content/Templates';

const MeetingActionButton = ({
  isPastMeeting,
  agendaResource,
}) => {
  const { householdResource } = useSimpleHousehold();

  return agendaResource.withRelationship(
    fr.relationships.thread.name,
    (rel) => (
      <FDSecondaryActionButton
        href={buildMemberMessagesPageLink(householdResource, rel.link('related').url())}
        label={isPastMeeting ? 'View Follow-up' : 'View Agenda'}
      />
    ),
    () => null,
  );
};

MeetingActionButton.propTypes = {
  isPastMeeting: PropTypes.bool.isRequired,
  agendaResource: PropTypes.object.isRequired,
};

export default MeetingActionButton;
